export function AboutSection() {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-about-section {
              padding: 40px 20px !important;
              align-items: center !important;
            }
            .mobile-about-title-container {
              margin-left: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              align-self: center !important;
              padding-bottom: 24px !important;
            }
            .mobile-about-title {
              font-size: 28px !important;
              line-height: 34px !important;
              letter-spacing: -0.5px !important;
            }
            .mobile-about-content {
              flex-direction: column !important;
              gap: 32px !important;
              align-items: center !important;
              width: 100% !important;
            }
            .mobile-about-description {
              padding-right: 0 !important;
              max-width: 100% !important;
              width: 100% !important;
              text-align: center !important;
            }
            .mobile-about-description-text {
              text-align: left !important;
              font-size: 14px !important;
              line-height: 24px !important;
            }
            .mobile-about-stats {
              gap: 0 !important;
              justify-content: space-between !important;
              width: 100% !important;
              flex-wrap: nowrap !important;
            }
            .mobile-about-stat-number {
              font-size: 28px !important;
            }
            .mobile-about-stat-label {
              font-size: 11px !important;
              padding-left: 0 !important;
            }
          }
        `,
        }}
      />
      <div className="w-full px-[60px] py-[40px] bg-slate-950 inline-flex flex-col justify-center items-center mobile-about-section">
        <div className="self-stretch pb-10 flex flex-col justify-start items-start">
          <div className="self-stretch inline-flex justify-start items-center gap-3">
            <div className="w-10 h-px" style={{ background: '#76BCE8' }} />
            <div className="size- inline-flex flex-col justify-start items-start">
              <div
                className="justify-center text-xs font-semibold font-['Inter'] uppercase tracking-[3px]"
                style={{ color: '#9DD0F0' }}
              >
                Hakkımızda
              </div>
            </div>
          </div>
        </div>

        <div
          className="w-[820px] max-w-[820px] pb-12 flex flex-col justify-start items-start mobile-about-title-container"
          style={{ marginLeft: '-227px' }}
        >
          <div className="w-full max-w-[820px] flex flex-col justify-start items-start">
            <div className="justify-center">
              <span
                className="text-8xl font-bold font-['Inter'] leading-[88px] mobile-about-title"
                style={{ color: '#FAFAFA' }}
              >
                Dijital dönüşümü
                <br />
              </span>
              <span
                className="text-8xl font-bold font-['Inter'] leading-[88px] mobile-about-title"
                style={{ color: 'rgba(255, 255, 255, 0.25)' }}
              >
                basitleştiren
              </span>
            </div>
            <div className="size- relative inline-flex justify-start items-start">
              <div
                className="justify-center text-8xl font-bold font-['Inter'] leading-[88px] mobile-about-title"
                style={{ color: '#FAFAFA' }}
              >
                ekosistem
              </div>
            </div>
          </div>
        </div>

        <div
          className="self-stretch inline-flex justify-center items-end mobile-about-content"
          style={{ gap: '23rem' }}
        >
          <div className="size- max-w-[460px] pr-5 inline-flex flex-col justify-start items-start mobile-about-description">
            <div
              className="justify-start text-base font-normal font-['Inter'] leading-8 mobile-about-description-text"
              style={{ color: 'rgba(255, 255, 255, 0.5)', textAlign: 'left' }}
            >
              Karmaşık iş süreçlerini akıllı otomasyon ve veri analitiği
              <br />
              ile yeniden tanımlıyoruz. 2024&apos;ten bu yana, yüzlerce
              <br />
              şirketin dijital yolculuğuna rehberlik ediyoruz.
            </div>
          </div>

          <div className="size- flex justify-start items-start gap-12 mobile-about-stats">
            <div className="self-stretch inline-flex flex-col justify-start items-end gap-1 mobile-about-stat-item">
              <div className="size- flex flex-col justify-start items-end">
                <div
                  className="text-right justify-center text-4xl font-bold font-['Inter'] mobile-about-stat-number"
                  style={{ color: '#FAFAFA' }}
                >
                  20+
                </div>
              </div>
              <div className="size- pl-12 flex flex-col justify-start items-end mobile-about-stat-label">
                <div
                  className="text-right justify-center text-xs font-medium font-['Inter']"
                  style={{ color: 'rgba(255, 255, 255, 0.25)' }}
                >
                  Müşteri
                </div>
              </div>
            </div>

            <div className="self-stretch inline-flex flex-col justify-start items-start gap-1 mobile-about-stat-item">
              <div className="self-stretch flex flex-col justify-start items-end">
                <div
                  className="text-right justify-center text-4xl font-bold font-['Inter'] mobile-about-stat-number"
                  style={{ color: '#FAFAFA' }}
                >
                  99.8%
                </div>
              </div>
              <div className="self-stretch flex flex-col justify-start items-end mobile-about-stat-label">
                <div
                  className="text-right justify-center text-xs font-medium font-['Inter']"
                  style={{ color: 'rgba(255, 255, 255, 0.25)' }}
                >
                  Uptime
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
